import { useEffect, useState } from "react";
import { api } from "../lib/api";
import ProductCard from "./ProductCard";

const STORAGE_KEY = "snip:recently_viewed";
const MAX = 12; // store last 12, display up to 4

/**
 * Push a slug onto the recently-viewed list (most recent first, unique).
 * Call this once per product page load (from ProductDetail).
 */
export function trackRecentlyViewed(slug) {
  if (!slug) return;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    const next = [slug, ...list.filter((s) => s !== slug)].slice(0, MAX);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // localStorage unavailable — silently ignore
  }
}

export default function RecentlyViewed({ excludeSlug }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let cancelled = false;
    let slugs = [];
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      slugs = raw ? JSON.parse(raw) : [];
    } catch {
      return;
    }
    const filtered = slugs.filter((s) => s !== excludeSlug).slice(0, 4);
    if (filtered.length === 0) {
      setProducts([]);
      return;
    }
    // Fetch each (small list — parallel). Skip any 404s.
    Promise.all(
      filtered.map((s) =>
        api.get(`/products/${s}`).then(({ data }) => data).catch(() => null)
      )
    ).then((results) => {
      if (cancelled) return;
      setProducts(results.filter(Boolean));
    });
    return () => { cancelled = true; };
  }, [excludeSlug]);

  if (products.length === 0) return null;

  return (
    <section className="mt-16 max-w-7xl mx-auto px-6" data-testid="recently-viewed">
      <div className="flex items-baseline justify-between gap-4 mb-6">
        <div>
          <div className="font-script text-2xl text-[#9c6dde]">come back to</div>
          <h2 className="font-display font-black text-3xl text-[#1c1815] tracking-tight">Recently Viewed</h2>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
        {products.map((p, i) => (
          <ProductCard key={p.id} product={p} index={i}/>
        ))}
      </div>
    </section>
  );
}
